// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3003":"css/app.6695","6579":"css/admin-app.6695"}[chunkId] + ".css";
};